module.exports = __webpack_public_path__ + "assets/img/wlzq.90ef7a2c.png";